module.exports = __webpack_public_path__ + "images/newerp_webicon.1790731042052.png";